import { render, staticRenderFns } from "./BlmXuanguMore.vue?vue&type=template&id=89402b2a&scoped=true"
import script from "./BlmXuanguMore.vue?vue&type=script&lang=js"
export * from "./BlmXuanguMore.vue?vue&type=script&lang=js"
import style0 from "./BlmXuanguMore.vue?vue&type=style&index=0&id=89402b2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89402b2a",
  null
  
)

export default component.exports